<template>
    <div class="p-px-2 p-p-0 p-mb-2">
        <small class="text-muted">Los campos marcados con * son requeridos.</small>
    </div>
    <form action="" @submit.prevent="guardar_cliente">
        <div class="p-fluid">
            <div class="p-mb-2 p-grid p-d-flex p-jc-between p-ai-center p-flex-wrap">
                <div class="p-col-3">
                    <label for="">*Nombres:</label>
                </div>
                <div class="p-col-9">
                    <InputText id="apellidos" @keydown="isvalid.nombres = true;" :class="{'p-invalid' : !isvalid.nombres }" autocomplete="off" v-model="form.nombre" placeholder="Escriba su apellido" />
                </div>
            </div>
            <div class="p-mb-2 p-grid p-d-flex p-jc-between p-ai-center p-flex-wrap">
                <div class="p-col-3">
                    <label for="">*Apellidos:</label>
                </div>
                <div class="p-col-9">
                    <InputText id="apellidos" @keydown="isvalid.apellidos = true;" :class="{'p-invalid' : !isvalid.apellidos }" autocomplete="off" v-model="form.apellido" placeholder="Escriba su apellido" />
                </div>
            </div>
            <div class="p-mb-2 p-grid p-d-flex p-jc-between p-ai-center p-flex-wrap">
                <div class="p-col-3">
                    <label for="">Contacto:</label>
                </div>
                <div class="p-col-9 p-inputgroup">
                    <InputMask v-model="form.celular" id="celular" autocomplete="off" mask="9999-9999" placeholder="Teléfono movil" />
                    <InputMask v-model="form.telefono" id="telefono" autocomplete="off" mask="9999-9999" placeholder="Teléfono fijo"/>
                </div>
            </div>
            <div class="p-mb-2 p-grid p-d-flex p-jc-between p-ai-center p-flex-wrap">
                <div class="p-col-3">
                    <label for="">*Correo:</label>
                </div>
                <div class="p-col-9">
                    <InputText id="correo_" ref="correo2" @keydown="isvalid.correo = true; correo_registrado = false;" autocomplete="off" :class="{'p-invalid' : !emailreg_is_valid || !isvalid.correo || correo_registrado }" v-model="form.correo" placeholder="Ej. ejemplo@gmail.com" />
                    <small class="text-danger" v-bind:class="{ 'p-hidden' : emailreg_is_valid }">Debe ingresar un correo válido.</small>
                    <small class="text-danger" v-bind:class="{ 'p-hidden' : isvalid.correo }">Debe ingresar el correo.</small>
                    <small class="text-danger" v-bind:class="{ 'p-hidden' : !correo_registrado }">El correo ingresado ya se encuentra registrado.</small>
                </div>
            </div>
            <div class="p-mb-2 p-grid p-d-flex p-jc-between p-ai-center p-flex-wrap">
                <div class="p-col-3">
                    <label for="celular">*Nacimiento:</label>
                </div>
                <div class="p-col-9">
                    <div class="p-d-flex p-ai-center p-jc-between p-inputgroup">
                        <Dropdown placeholder="Año" v-bind:class="{'p-invalid' : !isvalid.nacimiento}" style="flex-grow:2;" v-model="nacimiento.anio" :filter="true" :options="p_nacimiento.anios" optionLabel="value" optionValue="value" filterPlaceholder="Buscar año" />
                        <Dropdown placeholder="Mes" v-bind:class="{'p-invalid' : !isvalid.nacimiento}" style="flex-grow:2;" v-model="nacimiento.mes" :options="p_nacimiento.meses" optionLabel="name" optionValue="code" />
                        <Dropdown placeholder="Día" v-bind:class="{'p-invalid' : !isvalid.nacimiento}" style="flex-grow:2;" v-model="nacimiento.dia" :options="p_nacimiento.dias" optionLabel="value" optionValue="value" emptyMessage="Seleccione mes y año" />
                    </div>
                </div>
            </div>
            <div class="p-mb-2 p-grid p-d-flex p-jc-between p-ai-center p-flex-wrap">
                <div class="p-col-3">
                    <label for="">*Estado civil:</label>
                </div>
                <div class="p-col-9">
                    <Dropdown v-model="form.estado_civil" :class="{'p-invalid' : !isvalid.estado_civil }" :options="lista_estados_civiles" optionLabel="nombre" optionValue="codigo" placeholder="Seleccione" />
                </div>
            </div>
            <div class="p-mb-2 p-grid p-d-flex p-jc-between p-ai-center p-flex-wrap">
                <div class="p-col-3">
                    <label for="">*Género:</label>
                </div>
                <div class="p-col-9">
                    <Dropdown v-model="form.genero" :class="{'p-invalid' : !isvalid.genero }" :options="lista_generos" optionLabel="nombre" optionValue="codigo" placeholder="Seleccione" />
                </div>
            </div>
            <div class="p-mb-2 p-grid p-d-flex p-jc-between p-ai-center p-flex-wrap">
                <div class="p-col-3">
                    <label for="">*Contraseña:</label>
                </div>
                <div class="p-col-9">
                    <Password v-model="form.clave" @keydown="isvalid.clave = true;" :class="{'p-invalid' : !claves_coinciden || !isvalid.clave }" :feedback="false" toggleMask placeholder="Ingrese la contraseña"></Password>
                    <small class="text-danger" v-bind:class="{ 'p-hidden' : isvalid.clave }">Debe ingresar la clave.</small>
                </div>
            </div>
            <div class="p-mb-2 p-grid p-d-flex p-jc-between p-ai-center p-flex-wrap">
                <div class="p-col-3">
                    <label for="">*Confirmar:</label>
                </div>
                <div class="p-col-9">
                    <Password v-model="clave2" @keydown="isvalid.clave2 = true;" :class="{'p-invalid' : !claves_coinciden || !isvalid.clave2 }" :feedback="false" id="clave2" placeholder="Ingrese nuevamente la contraseña"></Password>
                    <small class="text-danger" v-bind:class="{ 'p-hidden' : claves_coinciden }">Las contraseñas no coinciden.</small>
                    <small class="text-danger" v-bind:class="{ 'p-hidden' : isvalid.clave2 }">Debe confirmar la clave.</small>
                </div>
            </div>
        </div>
        <div class="p-col-12 p-d-flex p-jc-between p-ai-center">
            <Button label="VOLVER" @click="cerrar_form()" icon="pi pi-angle-left" class="p-button-text p-button-secondary"></Button>
            <Button type="submit" label="Guardar registro" icon="pi pi-save" :loading="guardar_is_loading" />	
        </div>
    </form>
</template>

<script>
export default{
    name : 'RegistrarParticipante',
    props : {
        guardar_is_loading :{
            type : Boolean,
            default : false,
        },
        lista_estados_civiles : {
            type : Array
        },
        participante_registrado : {
            type : Number,
            default : 0,
        },
        correo_ocupado : {
            type : Number,
            default : 0,
        },
    },
    data (){
        return {
            lista_generos  : [
                {codigo : 'M',nombre : 'Masculino'},
                {codigo : 'F',nombre : 'Femenino'},
            ],
            form_is_valid : true,
            isvalid : {
                nombres : true,
                apellidos : true,
                correo : true,
                clave : true,
                clave2 : true,
                estado_civil : true,
                genero : true,
                nacimiento : true,
            },
            form : {
                nombre : '',
                apellido : '',
                celular : '',
                telefono : '',
                correo : '',
                clave : '',
                genero : '',
                estado_civil : '',
                nacimiento : '',
            },
            nacimiento : {
                anio : '',
                mes : '',
                dia : ''
            },
            p_nacimiento : {
				dias : [],
				meses : [],
				anios : [],
			},
            clave2 : '',
            correo_registrado : false,
            registro_exitoso : true,
            texto : "",
        }
    },
    methods : {
        async guardar_cliente(){
            this.correo_registrado = false;
            this.isvalid.nombres = this.form.nombre.length == 0 ? false : true;
            this.isvalid.apellidos = this.form.apellido.length == 0 ? false : true;
            this.isvalid.correo = this.form.correo.length == 0 ? false : true;
            this.isvalid.clave = this.form.clave.length == 0 ? false : true;
            this.isvalid.clave2 = this.clave2.length == 0 ? false : true;
            this.isvalid.genero = this.form.genero.length == 0 ? false : true;
            this.isvalid.estado_civil = this.form.estado_civil.length == 0 ? false : true;
            this.isvalid.nacimiento = this.form.nacimiento.length <= 7 ? false: true;
            this.form_is_valid = Object.values(this.isvalid).indexOf(false) >= 0 ? false : true;
            if(!this.form_is_valid || !this.claves_coinciden) return false;
            this.$emit('GuardarRegistro', this.form);
        },
        cerrar_form(){
            this.$emit('CerrarForm')
        },
    },
    computed : {
        fecha_nacimiento : function(){
            return this.nacimiento.dia + "/" + this.nacimiento.mes + "/" + this.nacimiento.anio;
        },
        claves_coinciden : function(){ 
            return ((this.form.clave != this.clave2) && (this.clave2 != '')) ? false : true 
        },
        emailreg_is_valid : function(){
            //eslint-disable-next-line
            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
            return this.form.correo == '' || this.form.correo == null ? true : re.test(this.form.correo)
        },
    },
    watch : {
        fecha_nacimiento (){
            this.form.nacimiento = this.fecha_nacimiento;
            this.p_nacimiento.dias = this.$date.dia_mes(this.nacimiento.mes, this.nacimiento.anio);
        },
        participante_registrado(){
            if(this.participante_registrado == 1){
                this.$toast.add({severity:'success', summary: 'Éxito', detail:'Se ha agregado el participante', life: 3000});
                this.$emit('ParticipanteRegistrado');
            }
        },
        correo_ocupado(){
            this.correo_registrado = this.correo_ocupado == 1 ? true : false;
        }
    },
    mounted (){
        this.p_nacimiento.meses = this.$date.meses();
        this.p_nacimiento.anios = this.$date.anios();
    },
}
</script>
